module.exports = __webpack_public_path__ + "bb1cabfd15971dbc85b5e095e7aeb8f9.svg";